// extracted by mini-css-extract-plugin
module.exports = {"s1s8dpim":"s1s8dpim"};